import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Country } from './country.model';
// import { CountriesModalComponent } from '../components/countries-modal/countries-modal.component';
import { CountryModalComponent } from '../components/country-modal/country-modal.component';
import { CountryTranslationModalComponent } from '../components/country-translation-modal/country-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CountryModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  // openCountriesModal(successCallback) {
  //   const options = {
  //     width: '700px', // 1000px
  //     minHeight: '80vh',
  //     maxHeight: '80vh',
  //     position: { top: '5vh' },
  //     disableClose: true,
  //     data: {
  //       title: 'COUNTRIES',
  //     },
  //     confirmCallback: successCallback,
  //     // preventCloseOnSave: true,
  //   };

  //   this.modalDialogService.open(options, CountriesModalComponent);
  // }

  openCountryModal(country, defaultLanguage, additionalLanguages, successCallback = null) {
    const confirmCallback = (result) => {
      // Edit
      if (country.id) {
        country.name = result.name;
        country.code = result.code;

        return this.utilService.changeItemRowStyle(country.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'COUNTRY_DETAILS',
        obj: country,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, CountryModalComponent);
  }

  openCountryTranslation(country: Country, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'COUNTRY_DETAILS',
        obj: country,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, CountryTranslationModalComponent);
  }
}
